<template>
  <div>
    <ResultStatus type="success" :title="$t('succeed_to_add_card')" style="margin-bottom: 120px;" />

    <md-button type="default" plain @click="$router.replace({ name: 'Card' })">{{ $t('back_to_homepage') }}</md-button>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
import ResultStatus from '@/components/ResultStatus'

// 成功状态
export default {
  name: 'Succeed',

  components: {
    [Button.name]: Button,
    ResultStatus
  }
}
</script>

<style scoped lang="scss">
</style>
